import { forwardRef, HTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

export const containerVariants = cva("ui-container", {
  variants: {
    size: {
      xs: "max-w-2xl",
      sm: "max-w-3xl",
      md: "max-w-5xl",
      lg: "max-w-7xl",
      xl: "max-w-[1440px]",
      full: "max-w-none",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export interface ContainerProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof containerVariants> {}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(function Container(
  { size, className, ...props },
  ref
) {
  return <div ref={ref} className={cn("w-full mx-auto px-4", containerVariants({ size, className }))} {...props} />;
});
